import i18n from 'localization';

export const errorCodeTypes = {
  unitNameAlreadyExistsError: {
    code: 'UN01',
    name: 'UnitNameAlreadyExistsError',
    message: i18n.t('shared.units.errors.nameExists'),
  },
  unitNameMinimumCharacterError: {
    code: 'UN02',
    name: 'UnitNameMinimumCharacterError',
    message: i18n.t('shared.units.errors.nameMinimumCharacter'),
  },
  unitNotFoundError: {
    code: 'UN03',
    name: 'UnitNotFoundError',
    message: i18n.t('shared.units.errors.notFound'),
  },
  unitTypeRequiredError: {
    code: 'UN04',
    name: 'UnitTypeRequiredError',
    message: i18n.t('shared.units.errors.typeRequired'),
  },
  unitExternalReferenceInvalidError: {
    code: 'UN05',
    name: 'UnitExternalReferenceInvalidError',
    message: i18n.t('shared.units.errors.externalReferenceInvalid'),
  },
  saveUnitExternalReferencesFailedError: {
    code: 'UN06',
    name: 'SaveUnitExternalReferencesFailedError',
    message: i18n.t('shared.units.errors.saveExternalReferencesFailed'),
  },
  getUnitExternalReferencesFailedError: {
    code: 'UN07',
    name: 'GetUnitExternalReferencesFailedError',
    message: i18n.t('shared.units.errors.getExternalReferencesFailed'),
  },
};
